import { isBrowser } from '@/utils/helper';

const storage = {
  set: (key: string, values: any) =>
    isBrowser && localStorage.setItem(key, values),
  get: (key: string) => isBrowser && localStorage.getItem(key),
  clear: () => isBrowser && localStorage.clear(),
  remove: (key: string) => isBrowser && localStorage.removeItem(key),
};

export default storage;
